export default class ExtranetOrdersIndex {
  constructor() {
    this.bindEvents();
    this.initDatatable();

    $("#order-step-filter").val("")
    this.step_filter.trigger('change');
  }

  bindEvents() {
    this.step_filter = $("#order-step-filter").select2({
      multiple: true,
      placeholder: "Selectionner des états",
      allowClear: true,
      closeOnSelect: false,
    })
  }

  initDatatable() {
    this.table = $("#orders-datatable").DataTable({
      "responsive": {
        details: {
          type: 'column',
          target: 'tr'
        }
      },
      "searching": true,
      stateSave: false,
      dom: 'rtp',
      "columnDefs": [
        {
          "targets": 0,
          "orderable": true,
          "visible": false
        },
        {
          "targets": -1,
          "orderable": false
        },
        {
          responsivePriority: 1,
          targets: [1, 2, 3, 9, 10]  // Name/tag, reference number, date, status and action buttons are highest priority
        },
        {
          responsivePriority: 2,
          targets: [4, 6]  // Product and client entity are medium priority
        }
      ],
      // Column 0 is the hidden waiting flag, column 3 the order date.
      "order": [[0, "desc"], [3, "desc"]],
      "language": {
        //url: '/assets/data-tables/locales/' + I18n.locale + '.json',
        previous: "<i class='mdi mdi-chevron-left'>",
        next: "<i class='mdi mdi-chevron-right>"
      },
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      drawCallback:function(){
        $(".dataTables_paginate > .pagination").addClass("pagination-rounded")
      }
    });

    this.initFilters();
  }

  initFilters() {
    let self = this;

    this.step_filter.change(function(e) {
      var selected = $(this).val();
      // Column 9 holds the status, and its data-search attribute carries the
      // translated label the select offers. This used to read column 7, which
      // never was the status column: the filter emptied the table instead of
      // narrowing it.
      if (selected && selected.length > 0) {
        self.table.column(9).search(selected.join('|'), true, false).draw();
      } else {
        self.table.column(9).search('', false, false).draw();
      }
    });

    $("#order_customSearch").off('keyup').on('keyup', function() {
      self.table.search($(this).val()).draw();
    });
  }

  onDataChanged(data) {
  }

  onDestroy() {
    this.step_filter.select2('destroy');
    this.table.destroy();
  }
}